module.exports = __webpack_public_path__ + "static/media/snt.50bd8634.jpg";